<template>
	<div class="content">
		<div class="tableTit">
			<p class="tabtitBg"></p>
			<h6>省、市、县-乡镇、三个责任人、防汛预案、运行管理落实情况表</h6>
			<el-select class="lefBitTop" v-model="formData.sheng" placeholder="请选择省" :disabled="shengdisabled==true"
				@change="shengChange">
				<el-option v-for="item in shengData" :key="item.regionCode" :label="item.regionName"
				:value="item.regionCode"></el-option>
			</el-select>
	
			<el-select class="lefBitTop" v-model="formData.shi" placeholder="请选择市" :disabled="shidisabled==true" @change="shiChange">
				<el-option v-for="item in shiData" :key="item.regionCode" :label="item.regionName"
				:value="item.regionCode"></el-option>
			</el-select>
	
			<el-select class="lefBitTop" v-model="formData.xian" placeholder="请选择县" :disabled="xiandisabled==true" @change="xianChange">
				<el-option v-for="item in xianData" :key="item.regionCode" :label="item.regionName"
				:value="item.regionCode"></el-option>
			</el-select>

			<!-- <el-button class="titBtn" type="primary" icon="el-icon-plus" @click="addClick()">新增</el-button> -->

			<!-- <el-button class="titBtn" type="success" @click="resets" icon="el-icon-refresh">重置</el-button> -->
			
			<el-button class="titBtn" type="success" icon="el-icon-search" @click="query()">搜索</el-button>

			<!--<div style="position: relative;float: right;"> 
				<el-input class="querys" v-model.trim="dw" placeholder="所在部门" @focus="focusval($event)" @blur="blurval1($event)"></el-input>
				<transition name="el-zoom-in-center">
					<div v-show="khdwshow" class="rowTopa" style="top: 50px;">
						<el-tree :data="datatree" class="paddingtree" :expand-on-click-node="false" :highlight-current='true' :default-expand-all="true" :props="defaultProps" @node-click="handleNodeClick" node-key='id' ref="treeList" :default-expanded-keys='[treesid]'>
						</el-tree>
					</div>
				</transition>
			</div>-->

			
			<el-input class="querys" v-model="ydbName" placeholder="输入坝名关键字搜索"></el-input>
			<el-button class="titBtn" type="primary" @click="toPrint(1)">导出</el-button>
			<el-button class="titBtn" type="primary" @click="toPrint(2)">打印报告</el-button>

		
		</div>
		<div class="tabBody">
			<el-table :data="tabledata" :height="tableHeight" border :header-cell-style="headerCelStyle"  :span-method="objectSpanMethod">
				<el-table-column type="index" align='center' width="60" label="序号"></el-table-column>
				<el-table-column prop="ydbSheng" align='center' label="省"></el-table-column>
				<el-table-column prop="ydbShi" align='center' label="市"></el-table-column>
				<el-table-column prop="ydbXian" align='center' label="县"></el-table-column>
				<!--<el-table-column prop="roleNames" align='center' label="角色名称"></el-table-column>-->
				<el-table-column prop="mobile" align='center' label="管理单位、坝">
					<el-table-column prop="ydbXiang" align='center' ></el-table-column>
					<el-table-column prop="ydbName" align='center' ></el-table-column>
					<el-table-column prop="ydbLx" align='center' ></el-table-column>
				</el-table-column>
					<el-table-column prop="ydbJcsx" align='center' label="检查事项"></el-table-column>
					<el-table-column prop="ydbJcxm" align='center' label="检查项目或对象"></el-table-column>
					<el-table-column prop="ydbWtms" align='center' label="问题描述"></el-table-column>
					<el-table-column prop="ydbFj" align='center' label="附件序号"></el-table-column>
					<el-table-column prop="ydbWtxh" align='center' label="问题序号"></el-table-column>
					<el-table-column prop="ydbWtfj" align='center' label="问题分级"></el-table-column>
					<el-table-column prop="" align='center' label="整改情况"></el-table-column>


				<el-table-column align='center' label="责任追究情况">
					<el-table-column prop="ydbZrdw" align='center' label="责任单位"></el-table-column>
					<el-table-column prop="ydbDwzjfs" align='center' label="追究方式"></el-table-column>
					<el-table-column prop="ydbZrr" align='center' label="责任人"></el-table-column>
					<el-table-column prop="ydbZrrzjfs" align='center' label="追究方式"></el-table-column>
				</el-table-column>
			</el-table>
		</div>
		<div class="fye">
			<pagintion @dsydata='DsyData' @dstdata="DstData" :ToTal='total' :pageNums="pageNums"></pagintion>
		</div>
		
		<!-- <userpopup v-if="dialogVisible == true" :mystate="Addsid" @getcancel="Getcancel" @adddata="Adddata"></userpopup> -->
	</div>
</template>
<script>
	import pagintion from '@/components/mangement/pagintion.vue';
	
	// import userpopup from "./popup/userpopup.vue";
	import {searchSpyOn,userdelete,initRegion,getRegion} from "@/api/api";
	
	import printJS from "print-js";
	
	export default {
		data() {
			return {
				tabledata: [],
				tableHeight: window.innerHeight - 180,
				total: 0,
				pageSize: 10, //每页多少条数据分页
				pageNum:1, //当前页
				pageNums: null,
				ydbName:'',
				dw:'',
				dialogVisible:false,
				Addsid:[],
				sjcdid:'',
				sjcd:'',
				datatree: [],
				defaultProps: { /// tree设置
					children: 'children',
					label: 'name'
				},
				khdwshow: false,
				treesid: '',
				shengData: null,
				shiData: null,
				xianData: null,
				shengdisabled: false,
				shidisabled: false,
				xiandisabled: false,
				rules: {
					sheng: [{
						required: true,
						message: '请选择省',
						trigger: 'change'
					}],
					shi: [{
						required: true,
						message: '请选择市',
						trigger: 'change'
					}],
					xian: [{
						required: true,
						message: '请选择县',
						trigger: 'change'
					}],
				},
				formData: {
					sheng: '',
					shi: '',
					xian: '',
				},
				ydbShengCode:'',
				ydbShiCode:'',
				ydbXianCode:'',
			}
		},
		components: {
			pagintion,
			// userpopup
		},
		mounted() {
			// let params={
			// 	pageSize: this.pageSize,
			// 	pageNum: this.pageNum,
			// 	ydbShengCode:this.ydbShengCode,ydbShiCode:this.ydbShiCode,ydbXianCode:this.ydbXianCode
			// }
			// this.list(params)
			this.$message({
				message: '请选择省市县',
				type: 'warning'
			});
			// 初始化
			this.initRegionFun()
		},
		methods: {
			// 省市县
			initRegionFun() {
				initRegion().then((res) => {
					// console.log('gis--->', res)
					this.shengData = res.sheng;
					this.shiData = res.shi;
					this.xianData = res.xian;
					if (this.shengData.length == 1) {
						this.formData.sheng = this.shengData[0].regionCode;
						this.shengdisabled = true;
					} else {
						this.formData.sheng = '';
						this.shengdisabled = false;
					}
					if (this.shiData.length == 1) {
						this.formData.shi = this.shiData[0].regionCode;
						this.shidisabled = true;
					} else {
						this.formData.shi = '';
						this.shidisabled = false;
					}
					if (this.xianData.length == 1) {
						this.formData.xian = this.xianData[0].regionCode;
						this.xiandisabled = true;
					} else {
						this.formData.xian = '';
						this.xiandisabled = false;
					}
				});
			},
			shengChange(value) {
				let params = {
					regionCode: value
				};
				getRegion(params).then((res) => {
					this.shiData = res.data;	
				});
				this.ydbShengCode = value
				this.formData.shi = '';
				this.formData.xian = '';
				this.shengAll = false;
				this.shiAll = false;
				this.xianAll = false;
			},
			shiChange(value) {
				let params = {
					regionCode: value
				};
				getRegion(params).then((res) => {
					this.xianData = res.data;
				});
				this.ydbShiCode = value
				this.formData.xian = '';
				this.shiAll = false;
				this.xianAll = false;
			},
			xianChange(value) {
				this.xianAll = false;
				this.ydbXianCode = value
				let params={
					pageSize: this.pageSize,
					pageNum: this.pageNum,
					ydbName:this.ydbName,
					ydbShengCode:this.ydbShengCode,ydbShiCode:this.ydbShiCode,ydbXianCode:this.ydbXianCode
				}
				this.list(params)
			},
			headerCelStyle({ row, column, rowIndex, columnIndex }) {
				row[4].rowSpan = 3;
				if (rowIndex === 1  && (columnIndex == 0|| columnIndex == 1 || columnIndex == 2 )) {
					return 'display:none'
				}else{
					return 'background:rgba(49,130,222,0.1)'
				}

			},
			// 表格合并
			objectSpanMethod({ row, column, rowIndex, columnIndex }) {
				if (columnIndex === 1 || columnIndex === 2 || columnIndex === 3 ) {
					if (rowIndex  === 0) {
						return {
							rowspan: this.total,  //第一列一直到底  todo:要考虑到不同的区
							colspan: 1
						};
					} else {
						return {
							rowspan: 0,
							colspan: 0
						};
					}
				}else{  //第四列
					if ((row.ydbXiang  === '省市县责任落实' || row.ydbXiang === '乡镇级责任落实') && columnIndex === 4) {  //第一个空
						return {
							rowspan: 1,
							colspan: 3
						};
					} else if ((row.ydbName  === '省市县责任落实' || row.ydbName === '乡镇级责任落实' || row.ydbLx  === '省市县责任落实' || row.ydbLx === '乡镇级责任落实') && ( columnIndex === 5 || columnIndex === 6)){ //第二第三
						return {
							rowspan: 0,
							colspan: 0
						};
					}
				}
			},


			handleNodeClick(data, e) {
				this.sjcdid = data.id;
				this.sjcd = data.name;
			},
			focusval(e) {
				this.khdwshow = true
			},
			blurval1(e) {
				let _this = this
				setTimeout(function() {
					_this.khdwshow = false
				}, 200)
			},
			
			query(){
				let params={
					pageSize: this.pageSize,
					pageNum: this.pageNum,
					ydbName:this.ydbName,
					ydbShengCode:this.ydbShengCode,ydbShiCode:this.ydbShiCode,ydbXianCode:this.ydbXianCode,
					
					//deptName:this.sjcd
				}
				this.list(params)
			},
			resets(){
				let params={
					pageSize: this.pageSize,
					pageNum: this.pageNum,
					ydbShengCode:this.ydbShengCode,ydbShiCode:this.ydbShiCode,ydbXianCode:this.ydbXianCode

				}
				this.list(params)
			},
			list(params){
				searchSpyOn(params).then((res)=>{
					this.total = res.total
					this.tabledata = res.data;
				})
				
			},
			// 打印报告获取所有的数据  跳转
			toPrint(flag){
				let newPage = this.$router.resolve({ 
					path: '/superPrint', 
					name:'superPrint',
					query: {ydbShengCode:this.ydbShengCode,ydbShiCode:this.ydbShiCode,ydbXianCode:this.ydbXianCode,flag:flag}
				});
				window.open(newPage.href, '_blank');
			},
			addClick(){
				this.Addsid = ['xz']
				this.dialogVisible = true;
			},
			Getcancel(data) {
				this.dialogVisible = data.dialogVisible;

			},
			Adddata(data) {
				this.dialogVisible = data.dialogVisible;
				let params={
					pageSize: this.pageSize,
					pageNum: this.pageNum,
					ydbShengCode:this.ydbShengCode,ydbShiCode:this.ydbShiCode,ydbXianCode:this.ydbXianCode
				}
				this.list(params)

			},
			DsyData(data) { //多少页
				console.log(data,'data-多少页----------')
				this.pageNum = data.dsy;
				let params = {
					pageSize: this.pageSize,
					pageNum: this.pageNum,
					ydbShengCode:this.ydbShengCode,ydbShiCode:this.ydbShiCode,ydbXianCode:this.ydbXianCode

				}
				this.list(params)
			},
			DstData(data) { //多少条
				console.log(data,'data-多少条----------')
				this.pageSize = data.dst;
				let params = {
					pageSize: this.pageSize,
					pageNum: this.pageNum,
					ydbShengCode:this.ydbShengCode,ydbShiCode:this.ydbShiCode,ydbXianCode:this.ydbXianCode

				}
				this.list(params)
			},
			edit(row, i) { //修改
				this.dialogVisible = true;
				this.Addsid = ['bj', row]
			},
			Reset(row, i) {
				this.$confirm('此操作将会重置您的密码,重置后新密码为123456, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(action => {
					if(action === 'confirm') {
						let params = {
							id: row.id
						};
						Resetpassword(params, this.tokens).then((res) => {
							if(res.code == 200) {
								this.$message1(res.message, 'success');
							} else {
								this.$message.error(res.message);
							}
						})
					}
				}).catch(() => {

					this.$message({
						message: '已取消',
						type: 'warning'
					});
				});
			},
			deletes(row, index) {
				this.$confirm('确定删除当前用户吗?此操作将永久删除, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(action => {
					if(action === 'confirm') {

						let params = {};
						userdelete({id:row.id}).then((res) => {
							if(res.code == 200) {
								this.$notify({
									title: "提示",
									message: res.message,
									type: "success",
								});
								let params = {
									pageSize: this.pageSize,
									pageNum: this.pageNum,
				
								}
								this.list(params)

							} else {
								this.$notify({
									title: "提示",
									message: res.message,
									type: "success",
								});
							}

						})
					}
				}).catch(() => {

					this.$message({
						message: '已取消',
						type: 'warning'
					});
				});
			},
		}
	}
</script>

<style scoped>
	@import url('../../common/css/mangementall.css');
	.querys {
		height: 30px;
		float: right;
		width: 200px;
		margin-top: 10px;
		margin-right: 10px;
	}
	/deep/.tableTit .el-input__suffix{
		top: 5px;
	}
	>>>.el-input__inner {
		height: 30px;
		line-height: 30px;
		color: #606266;

		font-size: 14px;
	}
	.lefBitTop{
		margin: 11px 0 0 10px;
	}
</style>